import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueAlertify from 'vue-alertify'
import VueLocalStorage from 'vue-localstorage'
import Router from 'vue-router'
import VueCollapse from 'vue2-collapse'

// import CheckLogin from '@/middlewaves/checkLogin'

import PageNotFound from '@/components/Page/PageNotFound'
import LoginPage from '@/components/Page/LoginPage'

import UpdateProfile from '@/components/Profile/UpdateProfile'
// import SettingStore from '@/components/SettingStore'
import Profile from '@/components/Profile/Profile'

import Home from '@/components/Page/Home'
import DownloadApps from '@/components/Page/DownloadApps'
import PlanArea from '@/components/Page/PlanArea'

import FurtherInfo from '@/components/Page/FurtherInfo'
import CallBackLogin from '@/components/Page/CallBackLogin'
import Page from '@/components/Page/Page'
import checkLogin from '../middlewaves/checkLogin'
import ManageGarden from '@/components/Cultivation/ManageGarden'
import FormStore from '@/components/forms/FormStore'
import FormGarden from '@/components/forms/FormGarden'
import ManageStore from '@/components/Store/ManageStore'
import SearchPackagerStore from '@/components/Store/SearchPackagerStore'
import ProfileStore from '@/components/Profile/ProfileStore'
import FormRegisterEncourageAgriculture from '@/components/forms/FormRegisterEncourageAgriculture'
import FormRegisterPlanArea from '@/components/forms/FormRegisterPlanArea'
import MyAgriculturalAd from '@/components//AgriculturalAd/MyAgriculturalAds'
import AgriculturalAds from '@/components//AgriculturalAd/AgriculturalAds'

import AgriculturalAdDetail from '@/components//AgriculturalAd/AgriculturalAdDetail'


const moment = require('moment')

Vue.use(VueLocalStorage)
Vue.use(Router)
Vue.use(VueAxios, axios)
Vue.use(VueAlertify)
Vue.use(VueCollapse)
require('moment/locale/vi')
Vue.use(require('vue-moment'), { moment })

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/danh-cho-nguoi-ban',
      name: 'MyAgriculturalAds',
      component: MyAgriculturalAd
    },
    {
      path: '/danh-cho-nguoi-mua',
      name: 'AgriculturalAds',
      component: AgriculturalAds
    },
    
    {
      path: '/agricultural-ads/:id',
      name: 'AgriculturalAdDetail',
      component: AgriculturalAdDetail
    },
    {
      path: '/tai-mobile-app',
      name: 'DownloadApps',
      component: DownloadApps
    },
    {
      path: '/tim-hieu-them/:type',
      name: 'FurtherInfo',
      component: FurtherInfo
    },
    {
      path: '/callback-login/:type',
      name: 'CallbackLogin',
      component: CallBackLogin
    },

    {
      path: '/vung-trong',
      name: 'PlanArea',
      component: PlanArea
    },
    {
      path: '/dang-ky-khuyen-nong',
      name: 'FormRegisterEncourageAgriculture',
      component: FormRegisterEncourageAgriculture,
      meta: {
        middleware: checkLogin
      }
    },
    {
      path: '/dang-ky-vung-trong',
      name: 'FormRegisterPlanArea',
      component: FormRegisterPlanArea,
      meta: {
        middleware: checkLogin
      }
    },
    {
      path: '/mygarden',
      name: 'ManageGarden',
      component: ManageGarden,
      meta: {
        middleware: checkLogin
      }
    }, {
      path: '/mygarden/add',
      name: 'AddGarden',
      component: FormGarden,
      meta: {
        middleware: checkLogin
      }
    }, {
      path: '/mygarden/edit/:id',
      name: 'EditGarden',
      component: FormGarden,
      meta: {
        middleware: checkLogin
      }
    },
    {
      path: '/mystore',
      name: 'ManageStore',
      component: ManageStore,
      meta: {
        middleware: checkLogin
      }
    },
    {
      path: '/store-profile/:storeId',
      name: 'ProfileStore',
      component: ProfileStore
    },
    {
      path: '/mystore/add/:type?',
      name: 'AddStore',
      component: FormStore,
      meta: {
        middleware: checkLogin
      }
    },
    {
      path: '/mystore/edit/:code',
      name: 'EditStore',
      component: FormStore,
      meta: {
        middleware: checkLogin
      }
    },
    {
      path: '/vua-thu-mua',
      name: 'SearchPackagerStore',
      component: SearchPackagerStore,
      meta: {
        middleware: checkLogin
      }
    },

    {
      path: '*',
      name: 'PageNotFound',
      component: PageNotFound
    }, {
      path: '/update-profile',
      name: 'UpdateProfile',
      component: UpdateProfile,
      meta: {
        middleware: checkLogin
      }
    },

    {
      path: '/profile/:profileId',
      name: 'Profile',
      component: Profile
    },
    {
      path: '/login',
      name: 'Login',
      component: LoginPage
    },
    {
      path: '/login/phone/:referral_phone',
      name: 'LoginReferral',
      component: LoginPage
    },
    {
      path: '/page/:slug/',
      name: 'Page',
      component: Page
    }
  ]
})

// Creates a `nextMiddleware()` function which not only
// runs the default `next()` callback but also triggers
// the subsequent Middleware function.
function nextFactory (context, middleware, index) {
  const subsequentMiddleware = middleware[index]
  // If no subsequent Middleware exists,
  // the default `next()` callback is returned.
  if (!subsequentMiddleware) return context.next

  return (...parameters) => {
    // Run the default Vue Router `next()` callback first.
    context.next(...parameters)
    // Than run the subsequent Middleware with a new
    // `nextMiddleware()` callback.
    const nextMiddleware = nextFactory(context, middleware, index + 1)
    subsequentMiddleware({ ...context, next: nextMiddleware })
  }
}

router.beforeEach((to, from, next) => {
  // console.log('from',from);
  if (from.name === 'Login') {
    if (window.REQUIRE_LOGIN_ROUTE_NAME) {
      console.log('window.REQUIRE_LOGIN_ROUTE_NAME', window.REQUIRE_LOGIN_ROUTE_NAME)
      window.REQUIRE_LOGIN_ROUTE_NAME = null
      window.ROUTE_PARAMS = null
      console.log('ok, set null')
    }
  }
  if (to.meta.middleware) {
    const middleware = Array.isArray(to.meta.middleware)
      ? to.meta.middleware
      : [to.meta.middleware]

    const context = {
      from,
      next,
      router,
      to
    }
    const nextMiddleware = nextFactory(context, middleware, 1)

    return middleware[0]({ ...context, next: nextMiddleware, to })
  }

  return next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js